import React from 'react';
import {ShopRegisterComponent} from '../../components';

export const ShopRegister: React.FC = () => {
  return <ShopRegisterComponent />;
};
